import React from 'react';
import { Card, Grid } from '@mui/material';
import { BorderedBox, CustomDivider, Information } from '@europrocurement/flexy-components';
import { findLabelByDocTypeId, FormaliteDocument } from '@europrocurement/l2d-domain';
import {
    ROLE_API_FORMALITE_TYPEDOC_DELETE,
    ROLE_API_FORMALITE_TYPEDOC_UPDATE,
    UseKeycloakService,
} from '@europrocurement/l2d-keycloak';
import { docStatusChoices } from '../documentTypeFormStructure';

type DocumentTypeCardProps = {
    documentType: FormaliteDocument;
    handleEditMainInformation: () => void;
    handleDelete: () => void;
};

const DocumentTypeCard: React.FunctionComponent<DocumentTypeCardProps> = function (props) {
    const { documentType, handleEditMainInformation, handleDelete } = props;
    const help = documentType.help as string | null | undefined;
    const libelleDF = documentType.libelleDF as string | null | undefined;

    const keycloakService = UseKeycloakService();
    return (
        <Card>
            <BorderedBox
                actionBarProps={{
                    ...(keycloakService.checkRole(ROLE_API_FORMALITE_TYPEDOC_UPDATE)
                        ? { editAction: handleEditMainInformation }
                        : {}),
                    ...(keycloakService.checkRole(ROLE_API_FORMALITE_TYPEDOC_DELETE)
                        ? { deleteAction: handleDelete }
                        : {}),
                }}
                borderWidth={0}
            >
                <Grid
                    container
                    spacing={2}
                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                >
                    <Grid
                        item
                        xs={12}
                        lg={6}
                    >
                        <BorderedBox
                            boxTitle="Informations générales"
                            borderWidth={3}
                        >
                            <Information
                                label="Libellé"
                                value={documentType.libelle as string}
                            />
                            <CustomDivider />
                            <Information
                                label="Nom interne"
                                value={(documentType.name as string) || undefined}
                            />
                            <CustomDivider />
                            <Information
                                label="Type"
                                value={
                                    documentType.type
                                        ? findLabelByDocTypeId(documentType.type)
                                        : undefined
                                }
                            />
                            <CustomDivider />
                            <Information
                                label="Libellé Dématfacile"
                                value={libelleDF || undefined}
                            />
                        </BorderedBox>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        lg={6}
                    >
                        <BorderedBox
                            boxTitle="Informations complémentaires"
                            borderWidth={3}
                        >
                            <Information
                                label="Signable"
                                value={documentType.signable ? 'Oui' : 'Non'}
                            />
                            <CustomDivider />
                            <Information
                                label="Typage automatique"
                                value={documentType.typageAuto ? 'Oui' : 'Non'}
                            />
                            <CustomDivider />
                            <Information
                                label="Document vide"
                                value={documentType.vide ? 'Oui' : 'Non'}
                            />
                            <CustomDivider />
                            <Information
                                label="Texte d'aide"
                                value={help || undefined}
                            />
                            <CustomDivider />
                            <Information
                                label="Statut par defaut"
                                value={
                                    docStatusChoices.find(
                                        (option) => option.value === documentType.statut,
                                    )?.label
                                }
                            />
                        </BorderedBox>
                    </Grid>
                </Grid>
            </BorderedBox>
        </Card>
    );
};

export default DocumentTypeCard;
